<template>
  <Map />
  <div  style="position: absolute; left: 10px; top: 10px;">
    <Header/>
    <Catalog></Catalog>
    <Legend
        :key="legendKey"
    />
  </div>
</template>

<script>
import Map from './components/Map.vue'
import Header from './components/Header.vue'
import Catalog from "@/components/Catalog"
import Legend from "@/components/Legend";
import axios from "axios";
import {token} from "@/data";

export default {
  name: 'App',
  components: {
    Legend,
    Catalog,
    Header,
    Map
  },
  data () {
    return {
      legendKey: 0
    }
  },
  computed: {
    /*token() {
      return this.$store.state.token
    }*/
  },
  method: {
  },
  beforeCreate() {
    /*if (process.env.NODE_ENV === 'production') {
      axios.get('./_token.json', /!*{ key: 'Cache-Control', value: 'no-cache'}*!/)
          .then(res => {
            this.$store.commit('setToken', res.data.token)
          })
      .catch(err => console.log('Couldnt authenticate'))
    } else {
      this.$store.commit('setToken', token)
    }*/
  }
}
</script>

<style>
html {
  position: absolute;
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
}
</style>
